export { default } from './primary-availability';
